import React from "react";
import "./whyChoseUs.css";
import {
  FeatureImage1,
  FeatureImage2,
  FeatureImage3,
  FeatureImage4,
  FeatureImage5,
  FeatureImage6,
  FeatureImage7,
  WorkImage,
} from "../../Assets";
import Fade from "react-reveal/Fade";

const WhyChoseUs = () => {
  const Data = [
    {
      id: 1,
      image: FeatureImage1,
      title: "Feature 1",
      detail:
        "Most Comprehensive and Feature-Packed Dex Aggregator/Swap Platform.",
    },

    {
      id: 2,
      image: FeatureImage2,
      title: "Feature 2",
      detail:
        "Multiwallet Buying Allowed (Purchase tokens with up to 3 wallets at once).",
    },

    {
      id: 3,
      image: FeatureImage3,
      title: "Feature 3",
      detail: "Blazing Fast Transactions.",
    },
    {
      id: 4,
      image: FeatureImage4,
      title: "Feature 4",
      detail: "Free to Use and Accessible to All",
    },
    {
      id: 5,
      image: FeatureImage5,
      title: "Feature 5",
      detail: "Convenient and User-Friendly Interface",
    },
    {
      id: 6,
      image: FeatureImage6,
      title: "Feature 6",
      detail: "Made for Everyday Degening",
    },
    {
      id: 7,
      image: FeatureImage7,
      title: "Feature 7",
      detail: "Constantly Building and Improving for an All-in-One Solution",
    },
  ];
  return (
    <section className="whyChoseUs_Main_Container">
      <Fade top>
        <p className="choseUS_Text_Style">Why Choose AlphaSwap?</p>
      </Fade>
      <Fade bottom>
        <div className="ChoseUs_Main_Wrapper">
          {Data.map((item) => {
            return (
              <div className="Swap_ChoseUs_Fade_Border_Style_container">
                <div className="Swap_ChoseUs_Fade_Border_Style">
                  <div className="ChoseUS-Image_Container">
                    <img src={item.image} className="ChoseUs_Image_Style" />
                  </div>
                  <p className="ChoseUs_Detail_Text_Style">{item.detail}</p>
                  <p className="ChoseUs_Title_TextStyle">{item.title}</p>
                </div>
              </div>
            );
          })}
        </div>
      </Fade>
      <Fade top>
        <p className="choseUS_Text_work_Style">How it Works</p>
      </Fade>
      <Fade bottom>
        <div className="ChoseUs_Image_Work_Style_Container">
          <img src={WorkImage} className="ChoseUs_Image_Work_Style" />
        </div>
      </Fade>
    </section>
  );
};

export default WhyChoseUs;
